




import React, { useState } from 'react';
import './ContactFormStyle.css';
import axios from 'axios';

export default function ContactForm() {
  // State for form fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  // State for form submission status
  const [status, setStatus] = useState({
    submitting: false,
    success: null,
    error: null
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Set submitting state
    setStatus({ submitting: true, success: null, error: null });
    
    try {
      // Send data to backend API (using your FastAPI endpoint)
      const response = await axios.post('https://site3.akms.org.in/backend/api/contact', formData);
      
      // Handle successful submission
      if (response.data.success) {
        setStatus({
          submitting: false,
          success: response.data.message,
          error: null
        });
        
        // Clear form fields
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        // Handle API error
        setStatus({
          submitting: false,
          success: null,
          error: response.data.message || 'Failed to send message. Please try again.'
        });
      }
    } catch (error) {
      // Handle network or other errors
      setStatus({
        submitting: false,
        success: null,
        error: error.response?.data?.message || 'An error occurred. Please try again later.'
      });
    }
  };

  return (
    <div className='from-container'>
      <h1>Send a message to us!</h1>
      
      {/* Display success message */}
      {status.success && (
        <div className="success-message">
          {status.success}
        </div>
      )}
      
      {/* Display error message */}
      {status.error && (
        <div className="error-message">
          {status.error}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <input 
          type="text"
          name="name"
          placeholder="Name" 
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input 
          type="email"
          name="email"
          placeholder="Email" 
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input 
          type="text"
          name="subject"
          placeholder="Subject" 
          value={formData.subject}
          onChange={handleChange}
          required
        />
        <textarea 
          name="message"
          placeholder="Message" 
          rows="4"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit" disabled={status.submitting}>
          {status.submitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
}